import {
  HighlightContentStatsName,
  HighlightPostContentType,
} from '../types/highlights'
// Get content type for highlight by link
// Usage: getHighlightContentType(link)
// This function try to identify content type by an url
export const getHighlightContentType = (
  link: string
): HighlightPostContentType => {
  // If link is empty, return OTHER
  if (!link) return HighlightPostContentType.OTHER

  // If link is a youtube video, return YT_VIDEO
  if (link.includes('youtube.com/shorts'))
    return HighlightPostContentType.YT_SHORT

  // If link is a youtube short, return YT_SHORT
  if (link.includes('youtu.be') || link.includes('youtube.com/watch'))
    return HighlightPostContentType.YT_VIDEO

  // If link is a tiktok video, return TIKTOK
  if (link.includes('tiktok.com')) return HighlightPostContentType.TIKTOK

  // If link is a instagram reel, return REEL
  if (link.includes('instagram.com/reel')) return HighlightPostContentType.REEL

  // If link is a instagram post, return POST
  if (link.includes('instagram.com/p')) return HighlightPostContentType.POST

  // If link is a instagram story, return STORY
  if (link.includes('instagram.com/stories'))
    return HighlightPostContentType.STORY

  // If link is a video, return VIDEO
  if (link.includes('.mp4')) return HighlightPostContentType.VIDEO

  // If link is a other, return OTHER
  return HighlightPostContentType.OTHER
}

export const getStatsTypeByContentType = (
  contentType?: HighlightPostContentType
) => {
  const mapper = {
    [HighlightPostContentType.OTHER]: Object.values(HighlightContentStatsName),
    [HighlightPostContentType.POST]: [
      HighlightContentStatsName.COMMENTS,
      HighlightContentStatsName.LIKES,
      HighlightContentStatsName.IMPRESSIONS,
      HighlightContentStatsName.REACH,
      HighlightContentStatsName.SAVES,
      HighlightContentStatsName.VIEWS,
      HighlightContentStatsName.VIDEO_VIEWS,
    ],
    [HighlightPostContentType.REEL]: [
      HighlightContentStatsName.COMMENTS,
      HighlightContentStatsName.LIKES,
      HighlightContentStatsName.PLAYS,
      HighlightContentStatsName.REACH,
      HighlightContentStatsName.SAVES,
      HighlightContentStatsName.SHARES,
      HighlightContentStatsName.INTERACTIONS_TOTAL,
    ],
    [HighlightPostContentType.STORY]: [
      HighlightContentStatsName.EXITS,
      HighlightContentStatsName.IMPRESSIONS,
      HighlightContentStatsName.REACH,
      HighlightContentStatsName.REPLIES,
    ],
    [HighlightPostContentType.TIKTOK]: [
      HighlightContentStatsName.LIKES,
      HighlightContentStatsName.COMMENTS,
      HighlightContentStatsName.SHARES,
      HighlightContentStatsName.VIEWS,
    ],
    [HighlightPostContentType.YT_SHORT]: [
      HighlightContentStatsName.VIEWS,
      HighlightContentStatsName.LIKES,
      HighlightContentStatsName.DISLIKES,
      HighlightContentStatsName.SHARES,
      HighlightContentStatsName.COMMENTS,
      HighlightContentStatsName.SAVES,
    ],
    [HighlightPostContentType.YT_VIDEO]: [
      HighlightContentStatsName.VIEWS,
      HighlightContentStatsName.LIKES,
      HighlightContentStatsName.DISLIKES,
      HighlightContentStatsName.SHARES,
      HighlightContentStatsName.COMMENTS,
      HighlightContentStatsName.SAVES,
    ],
    [HighlightPostContentType.VIDEO]: [
      HighlightContentStatsName.VIEWS,
      HighlightContentStatsName.LIKES,
      HighlightContentStatsName.DISLIKES,
      HighlightContentStatsName.SHARES,
      HighlightContentStatsName.COMMENTS,
      HighlightContentStatsName.SAVES,
    ],
  }
  if (!contentType) return mapper[HighlightPostContentType.OTHER]

  return mapper[contentType]
}

export const contentTypeName = (type?: HighlightPostContentType) => {
  if (!type) return ''
  const contentTypeArr = type.split('_')
  const contentTypeFixed = contentTypeArr.map((item) => {
    if (item === 'YT') return item
    return item.charAt(0).toUpperCase() + item.slice(1).toLowerCase()
  })

  return contentTypeFixed.join(' ')
}
